var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((Array(_vm.type === 'S' ? 10 : 5)),function(item,index){return _c('span',{key:index,class:[
      _vm.clsName,
      (_vm.scene === 'display' ? _vm.displayIndex : _vm.scoreIndex) >= index ? _vm.activeClsName : '',
      _vm.scene !== 'display' ? 'plv-iar-questionnaire-question__option--cursor' : '' ],on:{"click":function($event){return _vm.handleSelect(index)}}},[_vm._v(_vm._s(_vm.type === 'S' ? index + 1 : ''))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }